import { cn } from '@fe-learner-common';
import { FC, ReactNode } from 'react';

type TabPageProps = {
  className?: string;
  children: ReactNode;
  title: string;
  actions?: ReactNode;
};

export const TabPage: FC<TabPageProps> = ({
  className,
  children,
  title,
  actions,
}) => {
  return (
    <div className={cn('lf:flex lf:flex-col lf:px-4', className)}>
      <div className="lf:flex lf:flex-1 lf:justify-between ">
        <h2 className="lf:py-1.5 lf:pb-4 lf:text-title-lg">{title}</h2>
        {actions}
      </div>
      {children}
    </div>
  );
};
